import { createContext, type RefObject } from "react";
import type { AssistantCitation } from "@cmmd-forge/contracts";
import type { LegendListRef } from "@legendapp/list/react";
export interface AssistantCitationRequest {
  readonly citation: AssistantCitation;
  readonly key: string;
}
export interface AssistantCitationTarget extends AssistantCitationRequest {
  readonly activationRef: RefObject<{
    scrolled: boolean;
    dismissed: boolean;
    cancelScroll?: () => void;
    pulse?: { startedAt: number; reducedMotion: boolean };
  }>;
  readonly onComplete: () => void;
}
export const TimelineCitationContext = createContext<{
  readonly target: AssistantCitationTarget | null;
  readonly listRef: RefObject<LegendListRef | null>;
} | null>(null);
